import {v1 as uuidv1, v4 as uuidv4} from "uuid";

const UtilService = {
  uuidv4: function () {
    return uuidv4();
  },
  uuidv1: function () {
    return uuidv1();
  },
  isSaasUser: function (){
    let allowedSaasRoles = ["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]
    const storedRoles = JSON.parse(localStorage.getItem('CLASHMATE_ROLE_LIST')) || [];
    // Check if any of the allowedRoles are present in storedRoles
    const hasSaasUserRole = allowedSaasRoles.some(role => storedRoles.includes(role));
    console.log("hasSaasUserRole", hasSaasUserRole)
    return hasSaasUserRole;
  },
  isXgAdmin: function(){
    let allowedSaasRoles = ["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN"]
    const storedRoles = JSON.parse(localStorage.getItem('CLASHMATE_ROLE_LIST')) || [];
    // Check if any of the allowedRoles are present in storedRoles
    const hasSaasUserRole = allowedSaasRoles.some(role => storedRoles.includes(role));
    const currentTenantUID = localStorage.getItem('tenant');
    return currentTenantUID === process.env.REACT_APP_XGTen && hasSaasUserRole;
  },
  isLevel3: function(){
    let allowedSaasRoles = ["ROLE_LEVEL3"]
    const storedRoles = JSON.parse(localStorage.getItem('CLASHMATE_ROLE_LIST')) || [];
    // Check if any of the allowedRoles are present in storedRoles
    return allowedSaasRoles.some(role => storedRoles.includes(role));
  }
};

export default UtilService;
